import { sendErrorEvent } from '@trello/error-reporting';

import type { Attribute } from './fetchUserPersonalization';
import { fetchUserPersonalization } from './fetchUserPersonalization';
import type { Traits } from './traits';

export const getUserTraits = async (userId: string): Promise<Traits> => {
  try {
    const { attributes } = await fetchUserPersonalization(userId);

    const traits = attributes.reduce((obj: Traits, item: Attribute) => {
      obj[item.name] = item.value;
      return obj;
    }, {});

    return traits;
  } catch (error) {
    if (error instanceof Error) {
      sendErrorEvent(error, {
        tags: {
          ownershipArea: 'trello-cross-flow-b',
          feature: 'Atlassian Personalization',
        },
      });
    }

    throw error;
  }
};
